import { useNavigate } from "react-router-dom";
import Tool from "./tool";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

export default function Reference() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const refreshKey = i18n.language;

  return (
    <Tool
      key={refreshKey}
      title={t("announcement.resources")}
      url="/system/NFTReferenceRoom/list"
    >
      {({ list, pageNum, pageSize }) => (
        <div className="official-table">
          <table>
            <thead>
              <tr>
                <td>No</td>
                <td>{t("announcement.file_type")}</td>
                <td>{t("announcement.Title")}</td>
                <td>{t("announcement.date_posted")}</td>
                <td>{t("announcement.Views")}</td>
              </tr>
            </thead>
            <tbody>
              {list.map((item, idx) => (
                <tr
                  className="cursor-pointer"
                  key={item.id}
                  onClick={() =>
                    navigate("/announcement/reference-detail?id=" + item.id)
                  }
                >
                  <td>{(pageNum - 1) * pageSize + idx + 1}</td>
                  <td>PDF</td>
                  <td>
                    {item.top == 1 && (
                      <span className="badge">
                        {t("announcement.Recommend")}
                      </span>
                    )}
                    {item.title}
                  </td>
                  <td>{dayjs(item.createTime).format("YY.MM.DD HH:mm:ss")}</td>
                  <td>{item.click}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Tool>
  );
}
